// StoreCard.js
import React from 'react';
import { useNavigate } from "react-router-dom";
import './QuestionSetCard.css';

const formatDateTime = (isoString) => {
  if (!isoString) return '-';
  const date = new Date(isoString);
  const pad = (n) => (n < 10 ? '0' + n : n);
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

const StoreCard = ({ store, imageUrl }) => {
  const navigate = useNavigate();

  const title = store?.label || store?.name || '店家';
  const followedAt = store?.followedAt || store?.updatedAt || store?.createdAt;

  return (
    <div
      className="d-flex rounded submitted-question-set-card-div"
      style={{ borderBottom: '1px solid #eee', padding: '12px 5px 18px 15px', cursor: 'pointer' }}
    >
      <img
        src={imageUrl}
        alt={title}
        style={{ width: '55px', height: '55px', borderRadius: '50%', marginRight: '20px' }}
        onClick={(e) => {
          e.stopPropagation();
          // TODO: update route if there is a dedicated store detail route
          // navigate(`/myInfo/storeMenu/stores/${store._id}`)
        }}
      />

      <div className="d-flex flex-column justify-content-center">
        <h6 className="mb-1">{title}</h6>
        <small className="text-muted">追蹤時間: {formatDateTime(followedAt)}</small>
      </div>
    </div>
  );
};

export default StoreCard;
